import './Footer.scss';

import React from 'react';

export default function Footer() {
  return <div className="footer">
    <div className="footer__brand">Logicort automatizált nyilvántartó rendszer @ Applixation 2019</div>
    <div className="footer__links"><a href="mailto:info@logicort.hu">info@logicort.hu</a> • <a href="https://www.logicort.hu">www.logicort.hu</a></div>
  </div>
};